import { Component, OnInit, EventEmitter, ViewChild, Output } from '@angular/core';
import { faAngleDown, faAngleUp, faPlusSquare, faCartPlus, faShoppingCart, faQuestionCircle, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { PROTOCOL } from 'src/app/models/protocols';
import { StixService } from 'src/app/stix-service.service';
import { MatDialog } from '@angular/material/dialog';
import { MultipartDialogComponent } from 'src/app/dialogs/multipart-dialog/multipart-dialog.component';
import { environment } from 'src/environments/environment';
import { GuidedService } from 'src/app/guided.service';
import { GuidedCartComponent } from '../guided-cart/guided-cart.component';
import * as moment from 'moment';
import * as moment_tz from 'moment-timezone';

@Component({
  selector: 'app-how-observable',
  templateUrl: './how-observable.component.html',
  styleUrls: ['./how-observable.component.css']
})
export class HowObservableComponent implements OnInit {
  @ViewChild("guidedCart", { static: false }) guidedCart: GuidedCartComponent;

  //With Cart
  @Output() disableCartEmitter = new EventEmitter<boolean>();
  @Output() newItemEmitter = new EventEmitter<any>();
  @Output() editModeEmitter = new EventEmitter<boolean>();
  @Output() syncCartEmitter = new EventEmitter<any>();
  @Output() getEditItemEmitter = new EventEmitter<any>();

  //With Parent
  @Output() showAssistance = new EventEmitter<any>();
  @Output() changePage = new EventEmitter<any>();

  component: string = 'how-observable'

  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faCartPlus = faCartPlus;
  faPlus = faPlus;
  faTrash = faTrash;
  faCart = faShoppingCart;
  faQuestionCircle = faQuestionCircle;

  observed = null;
  currentObservableType: string = '';
  currentObservableAlignment: string = '';
  currentAttacker: string = '';
  currentTarget: string = '';
  // timeZone: string = '';
  numberObserved: string = '';
  firstObserved: string = '';
  lastObserved: string = '';
  firstObservedTimeZone: string = '';
  lastObservedTimeZone: string = '';
  first_seen: Date;
  last_seen: Date;
  currentObservableInfo: any[] = [];
  currentObservableInput: any[] = [];
  listOfAttackers: any[] = [];
  listOfTargets: any[] = [];
  previousAlignment: string;
  alignment: any;

  timeZoneOptions: any[] = [];
  moment = moment;
  moment_tz = moment_tz;

  observableTypeDropdown: boolean = false;
  observableValueDropdown: boolean = false;
  observableTimeDropdown: boolean = false;
  observableAlignmentDropdown: boolean = false;
  showObservableAlignment: boolean = false;
  showObservableTime: boolean = false;

  cartIds: number[] = [];
  objectIds: string[] = [];
  editMode: boolean = false;

  firstDateStart: Date;
  lastDateStart: Date;

  networkTrafficOptions: string[] = this.getNetworkTrafficOptions();

  malwareAnalysisResultOptions = [
    'Malicious',
    'Suspicious',
    'Benign',
    'Unknown'
  ];

  observableOptions: any[] = [
    'Artifact',
    'Autonomous System',
    'Directory',
    'Domain Name',
    'Email Address',
    'Email Message',
    'File',
    'IPv4 Address',
    'IPv6 Address',
    'Mac Address',
    'Malware',
    'Malware Analysis',
    'Mutex',
    'Network Traffic',
    'Process',
    'Software',
    'URL',
    'User Account',
    'Windows Registry Key',
    'X509 Certificate'
  ]

  observableInfo: any = {
    'Artifact' : [
      'An array of bytes (8-bit) as a base64 encoded string',
      'A link to a file-like payload'
    ],
    'Autonomous System' : [
      'Properties of one or more an Autonomous System (AS)',
      'Suggested details include: Name, Number, and Regional Internet Registry (RIR)'
    ],
    'Directory': [
      'Properties of one or more file system directory paths and associated meta-data',
      'Suggested details include: full path (example “c:windowssystem32” OR “/tmp” ), path encoding, creation time, modification time, and access time'
    ],
    'Domain Name' : [
      'Properties of one or more network domain name and associated meta-data',
      'Suggested details include: domain name, canonical name, and IPv4 or IPV6 address(es) the domain resolves to'
    ],
    'Email Address' : [
      'Properties of one or more email addresses',
      'Suggested details include: email address, display name, and associated user account'
    ],
    'Email Message' : [
      'The headers are raw content of one or more email messages'
    ],
    'File' : [
      'Properties of one or more file system directory paths and associated meta-data',
      'Suggested details include: full path (example “c:windowssystem32” OR “/tmp” ), path encoding, creation time, modification time, and access time'
    ],
    'IPv4 Address' : [
      'One or more IPv4 addresses',
      'Suggested details include: IPv4 addresses'
    ],
    'IPv6 Address' : [
      'One or more IPv6 addresses',
      'Suggested details include: IPv6 addresses'
    ],
    'Mac Address': [
      'Specifies the value of a single MAC address.',
      'The MAC address value MUST be represented as a single colon-delimited, lowercase MAC-48 address, which MUST include leading zeros for each octet.'
    ],
    'Mutex': [
      'Properties of a Mutual Exclusion Object',
      'Suggested details include: name and if known associated application or system resource'
    ],
    'Network Traffic': [
      'Network traffic that originates from a source and is addressed to a destination',
      'Suggested Details include: start date & time, end date & time, source ip(s), destination ip(s), source port(s), destination port(s), protocol(s), session flags, packet counts, byte counts, netflow snippets, ipfix data ( must be in key:value pair format ), Zeek log snippets, and other traffic log snippets'
    ],
    'Process': [
      'Properties of one or more system processes',
      'Suggested details include: name, process id, created time, command line, environment variables, process parent(s), process child(ren), is process hidden, current working directory, is ASLR enabled, is dep enabled, window title, integrity level, and hash ( must include hash algorithm and hash value separated by a colon, example md5:d41d8cd98f00b204e9800998ecf8427e )'
    ],
    'Software' : [
      'Properties of one or more software applications',
      'Suggested details include: name, version, and vendor'
    ],
    'URL' : [
      'The properties of a Uniform Resource Locator (URL)',
      'Suggested details include: the string value of URL OR string value of the URL and associated Uniform Resource Information (URI)'
    ],
    'User Account': [
      'Properties of one or more instances of any type of user account, including but not limited to operating system, device, messaging service, and social media platform accounts.',
      'Suggested details include: user id, account login string, account type, display name, identity management service, is this a service account, is this a privileged account, can this account escalate privileges, creation date, credential change date, first logon date, last logon date, is Multi-Factor Authentication (MFA) enabled, MFA type, MFA service provider, is the credential hardcoded, groups the account is a member of, the home directory, and command shell'
    ],
    'Windows Registry Key': [
      'Properties of one or more instances of any type of user account, including but not limited to operating system, device, messaging service, and social media platform accounts.',
      'Suggested details include: user id, account login string, account type, display name, identity management service, is this a service account, is this a privileged account, can this account escalate privileges, creation date, credential change date, first logon date, last logon date, is Multi-Factor Authentication (MFA) enabled, MFA type, MFA service provider, is the credential hardcoded, groups the account is a member of, the home directory, and command shell'
    ],
    'X509 Certificate': [
      'Properties and values of an X.509 certificate.',
      'Suggested details include: is it self signed, version, serial number, signature algorithm, issuer, valid not before date, valid not after date, certificate hash ( calculated for the entire contents of the hash ), subject, and subject public key algorithm',
      'Suggested X.509 extension details include: basic constraints, name constraints, policy constraints, key usage, extended key usage, subject key identifier, authority key identifier, subject alternative name, issuer, alternative name, issuer alternative name, crl distribution points, inhibit any policy value, private key usage period not before, private key usage period not after, and certificate policies value(s)'
    ]
  }

  observableInputFields: any = {
    'Artifact': [
      {
        index: 0,
        field_options: ['URL', 'Payload Bin', 'Hash'],
        placeholders: {
          'URL': 'Enter URL or URI', 
          'Payload Bin': 'Enter Payload Bin',
          'Hash': 'Enter Hash'
        },
        select_placeholder: 'Select Field',
        currentPlaceholder: '',
        currentField: '',
        type: 'hybrid',
        value: '',
        show: true,
        error: ''
      },
      {
        index: 1,
        placeholder: 'Enter Hash',
        type: 'text',
        value: '',
        currentField: 'hashes',
        show: false,
        error: ''
      }
    ],
    'Autonomous System': [
      {
        placeholder: 'Enter Number',
        type: 'number',
        value: '',
        currentField: 'number',
        show: true,
        error: ''
      }
    ],
    'Directory': [
      {
        placeholder: 'Enter Path',
        type: 'text',
        value: '',
        currentField: 'path',
        show: true,
        error: ''
      }
    ],
    'Domain Name': [
      {
        placeholder: 'Enter Domain Name',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'Email Address': [
      {
        placeholder: 'Enter Email Address',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'Email Message': [
      {
        index: 0,
        placeholder: 'Is Body Multipart?',
        type: 'select',
        options: ['true', 'false'],
        value: '',
        currentField: 'is_multipart',
        show: true,
        error: ''
      },
      {
        index: 1,
        currentPlaceholder: 'Build Body Multipart -->',
        type: 'text-modal-add',
        value: '',
        currentField: 'body_multipart',
        show: false,
        error: '',
        arr: []
      }
    ],
    'File': [
      {
        index: 0,
        field_options: ['Name', 'Hash'],
        placeholders: {
          'Name': 'Enter Name',
          'Hash': 'Enter Hash'
        },
        select_placeholder: 'Select Field',
        currentPlaceholder: '',
        type: 'hybrid',
        value: '',
        currentField: '',
        show: true,
        error: ''
      }
    ],
    'IPv4 Address': [
      {
        placeholder: 'Enter IPv4',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'IPv6 Address': [
      {
        placeholder: 'Enter IPv6',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'Mac Address': [
      {
        placeholder: 'Enter Mac Address',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'Malware': [
      {
        index: 0,
        placeholder: 'Enter Name',
        type: 'text',
        value: '',
        currentField: 'name',
        show: true,
        error: ''
      },
      {
        index: 1,
        placeholder: 'Is Family?',
        type: 'select',
        options: ['true', 'false'],
        value: '',
        currentField: 'is_family',
        show: true,
        error: ''
      },
    ],
    'Malware Analysis': [
      {
        index: 0,
        placeholder: 'Enter Product',
        type: 'text',
        value: '',
        currentField: 'product',
        show: true,
        error: ''
      },
      {
        index: 1,
        field_options: ['Result', 'Analysis Sco Refs'],
        placeholders: {
          'Result': 'Enter Result',
          'Analysis Sco Refs': 'Enter Ref'
        },
        hybrid_placeholder: '',
        hybrid_options: [],
        select_placeholder: 'Select Field',
        currentPlaceholder: '',
        currentField: '',
        type: 'hybrid-hybrid',
        type_options: {
          'Result': 'hybrid-hybrid',
          'Analysis Sco Refs': 'hybrid-hybrid-add'
        },
        value: '',
        show: true,
        error: '',
        arr: []
      }
    ],
    'Mutex': [
      {
        placeholder: 'Enter Name',
        type: 'text',
        value: '',
        currentField: 'name',
        show: true,
        error: ''
      }
    ],
    'Network Traffic': [
      {
        index: 0,
        field_options: this.networkTrafficOptions,
        placeholders: {},
        currentPlaceholder: 'Enter Protocol',
        currentField: 'protocols',
        select_placeholder: 'Select Protocol',
        type: 'hybrid-add',
        value: '',
        show: true,
        error: '',
        arr: []
      },
      {
        index: 1,
        field_options: ['Source Ref', 'Target Ref'],
        placeholders: {
          'Source Ref': 'Enter Source',
          'Target Ref': 'Enter Target'
        },
        hybrid_placeholder: '',
        hybrid_options: [],
        select_placeholder: 'Select Ref',
        currentPlaceholder: '',
        currentField: '',
        type: 'hybrid-hybrid',
        value: '',
        show: false,
        error: ''
      }
    ],
    'Process': [
      {
        placeholder: 'Enter Process ID',
        type: 'text',
        value: '',
        currentField: 'pid',
        show: true,
        error: ''
      }
    ],
    'Software': [
      {
        placeholder: 'Enter Name',
        type: 'text',
        value: '',
        currentField: 'name',
        show: true,
        error: ''
      }
    ],
    'URL': [
      {
        placeholder: 'Enter URL or URI',
        type: 'text',
        value: '',
        currentField: 'value',
        show: true,
        error: ''
      }
    ],
    'User Account': [
      {
        placeholder: 'Enter User ID',
        type: 'text',
        value: '',
        currentField: 'user_id',
        show: true,
        error: ''
      }
    ],
    'Windows Registry Key': [
      {
        placeholder: 'Enter Registry Key',
        type: 'text',
        value: '',
        currentField: 'key',
        show: true,
        error: ''
      }
    ],
    'X509 Certificate': [
      {
        placeholder: 'Enter Serial Number',
        type: 'text',
        value: '',
        currentField: 'serial_number',
        show: true,
        error: ''
      }
    ],
  }

  validationRegex = {
    'url': new RegExp('^(?:[A-Za-z][A-Za-z0-9+.-]*:\/{2})+www[.]+(?:(?:[A-Za-z0-9-._~]|%[A-Fa-f0-9]{2})+(?::([A-Za-z0-9-._~]?|[%][A-Fa-f0-9]{2})+)?@)?(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.){1,126}[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?::[0-9]+)?(?:\/(?:[A-Za-z0-9-._~]|%[A-Fa-f0-9]{2})*)*(?:\\?(?:[A-Za-z0-9-._~]+(?:=(?:[A-Za-z0-9-._~+]|%[A-Fa-f0-9]{2})+)?)(?:&|;[A-Za-z0-9-._~]+(?:=(?:[A-Za-z0-9-._~+]|%[A-Fa-f0-9]{2})+)?)*)?$'),
    'payload_bin': new RegExp(/^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{3}=|[A-Za-z\d+/]{2}==)?$/),
    'path': new RegExp('^(.*)(/|\\\\)+([^/]*)$'),
    'domain_name': new RegExp('^((?!-))(xn--)?[a-z0-9][a-z0-9-_]{0,61}[a-z0-9]{0,1}\.(xn--)?([a-z0-9\-]{1,61}|[a-z0-9-]{1,30}\.[a-z]{2,})$'),
    'email_address': new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
    'ipv4_address': new RegExp('^((' + '(((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])[.]){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9]))' + '([/](3[0-2]|2[0-9]|[1-9]))?)|((' + '(((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])[.]){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9]))'  + '[/](3[0-2]|2[0-9]|[1-9]))+))$'),
    'ipv6_address': new RegExp('^((' + '\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))\s*' + '([/](12[0-8]|1[01][0-9]|[1-9][0-9]|[1-9]))?)|((' + '\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))\s*' + '[/](12[0-8]|1[01][0-9]|[1-9][0-9]|[1-9]))+))$'),
    'mac_address': new RegExp('^([0-9a-f]{2}[:]){5}([0-9a-f]{2})|([0-9a-f]{2}[-]){5}([0-9a-f]{2})$'),
    'pid': new RegExp('^-?[1-9][0-9]*|0$'),
    'key': new RegExp('^HKEY_CURRENT_CONFIG|^HKEY_CURRENT_USER|^HKEY_LOCAL_MACHINE|^HKEY_USERS|^hkey_current_config|^hkey_current_user|^hkey_local_machine|^hkey_users$'),
    'ref': new RegExp('^(ipv4-addr|ipv6-addr|mac-addr|domain-name)--[0-9a-f]{8}\-[0-9a-f]{4}\-[45][0-9a-f]{3}\-[89ab][0-9a-f]{3}\-[0-9a-f]{12}$')
  }

  alignmentPlaceholder: any = {
    '':'',
    'Target': 'Target Name',
    'Attacker': 'Attacker Name',
    'Unknown': '',
    'Benign': ''
  }

  constructor(private stixService: StixService,
              public multipartDialog: MatDialog,
              public guidedService: GuidedService) { }

  ngOnInit(): void {
    this.timeZoneOptions = this.moment_tz.tz.names();

    if (this.guidedService.cart['who-individual']) {
      if (this.guidedService.cart['who-individual']['Identity'])
        this.guidedService.cart['who-individual']['Identity'].forEach(identity => this.listOfTargets.push(identity));
      if (this.guidedService.cart['who-individual']['Threat Actor'])
        this.guidedService.cart['who-individual']['Threat Actor'].forEach(threatActor => this.listOfAttackers.push(threatActor));
    }
    
    const editCartTimeout = setTimeout( () => {
      if(this.guidedService.editCartObject.component && this.guidedService.editCartObject.component === this.component){
        this.getEditItemEmitter.emit(this.guidedService.editCartObject);
      }
    }, 100);
  }

  addCartItem(cancel){
    if(cancel){
      this.reset();
      this.editMode = false;
      return;
    }

    let stixObject: any = {};
    let lowercaseType: string = '';
    let objectType: string = '';

    lowercaseType = this.currentObservableType.toLowerCase();
    objectType = lowercaseType.split(' ').join('-');
    objectType = objectType.replace('address', 'addr');

    stixObject.type = objectType;
    stixObject.spec_version = '2.1';

    for(let field of this.currentObservableInput){
      if(field.show === false){
        continue;
      }

      field.currentField = this.getCurrentFieldName(field.currentField);
      switch(field.currentField){
        case 'hashes':
          stixObject['hashes'] = this.identifyHashes(field.value);
          break;
        case 'protocols':
        case 'body_multipart':
        case 'analysis_sco_refs':
          if(field.arr.length !== 0 && field.show === true)
            stixObject[`${field.currentField}`] = field.arr;
          break;
        default:
          stixObject[`${field.currentField}`] = field.value;
      }
    }

    let now = new Date();

    switch(this.currentObservableType){
      case 'Malware':
        stixObject['created_by_ref'] = environment.cisaIdentity.id;
        stixObject['created'] = now.toUTCString();
        break;
      case 'Malware Analysis':
        stixObject['created'] = now.toUTCString();
        break;
    }

    stixObject['cartId'] = this.cartIds[0] ? this.cartIds[0] : null;
    stixObject['id'] = this.objectIds[0] ? this.objectIds[0] : this.getStixId(stixObject);

    if(this.showObservableAlignment === true){
      stixObject['alignment'] = this.currentObservableAlignment !== '' ? this.currentObservableAlignment : null;
      stixObject['target'] = this.currentObservableAlignment === 'Target' ? this.currentTarget : null;
      stixObject['attacker'] = this.currentObservableAlignment === 'Attacker' ? this.currentAttacker : null;
    }

    let emitObj = {
      mode: this.component,
      push: [
        stixObject
      ]
    }

    let observed = this.getObserved(stixObject.id);

    if (!observed && this.observed && this.observed.id) {
      this.guidedService.observablesToRemove.push(this.observed.id);
    }

    if(observed !== false){
      emitObj.push.push(observed);
    }

    this.newItemEmitter.emit(emitObj);
    this.disableCartEmitter.emit(true);
    this.reset();
  }

  getStixId(object){
    let typeName = this.getObjectTypeName(object.type);
    if(this.guidedService.editCart && this.guidedService.editCart[this.component] && this.guidedService.editCart[this.component][typeName]){
      for(let oldObject of this.guidedService.editCart[this.component][typeName]){
        if(oldObject.cartId === object.cartId){
          return oldObject.id;
        }
      }
    }

    return `${object.type}--${this.stixService.getUUIDFrIdContributingProperties(object)}`;
  }

  getObjectTypeName(type){
    let result = '';
    let split = type.split('-');
    for(let i in split){
      let word = split[i];

      if(word === 'addr'){
        split[i] = 'Address';
        continue;
      } else if(word === 'url') {
        split[i] = 'URL';
        continue;
      } else if (word.startsWith('ip')){
        let firstLetter = word.charAt(0).toUpperCase();
        let secondLetter = word.charAt(1).toUpperCase();

        split[i] = `${firstLetter}${secondLetter}${word.slice(2)}`;
        continue;
      }

      let firstLetter = word.charAt(0).toUpperCase();
      split[i] = `${firstLetter}${word.slice(1)}`;
    }

    result = split.join(' ');

    return(result);
  }

  addComponents(){
    if(this.guidedCart.cartLength === 0){
      this.reset();
      return;
    }
    let types = [];
    let data = [];

    for(let type in this.guidedCart.cart){
      let objects = this.guidedCart.cart[type];

      for(let obj of objects){
        types.push(obj.type);
        let times: any;

        switch(obj.type){
          case 'sighting':
            times = this.convertToUTC(obj.timeZone, obj.first_seen, obj.last_seen);
            if(times.first){
              obj.first_seen = times.first.toISOString();
            }
            if(times.last){
              obj.last_seen = times.last.toISOString();
            }
            break;
          case 'observed-data':
            times = this.convertToUTC(obj.timeZone, obj.first_observed, obj.last_observed);
            if(times.first){
              obj.first_observed = times.first.toISOString();
            }
            if(times.last){
              obj.last_observed = times.last.toISOString();
            }
        }

        if(obj.timeZone) delete obj.timeZone;
        if(obj.display_name) delete obj.display_name;
        if(obj.cartId) delete obj.cartId;
        if(obj.linkId) delete obj.linkId;

        if(obj.alignment){
          this.guidedService.observablesWithAlignment.push(JSON.parse(JSON.stringify(obj)));
          if(obj.alignment === 'Attacker'){
            this.guidedService.addAttacker(obj.attacker);
            delete obj.attacker;
          }

          delete obj.alignment;
        }

        data.push(obj);
      }
    }

    this.guidedService.addComponents(types, data);
    this.reset();

    
    if (this.guidedService.autoGenRelationships) {
      // Build relationship: Observable target alignment --- Identity (map each observable target alignment to identity sequentially)
      setTimeout(() => {
        this.guidedService.findPreviouslyAddedObjects('identity', 'identity-observable');
        this.guidedService.addedObjects.subscribe(addedObjects => {
          if (addedObjects.eventType === 'identity-observable'
            && addedObjects.objects
            && addedObjects.objects.length > 0) {

              let identities = addedObjects.objects;
              identities.sort(function(a, b) {
                if (a.created < b.created) { return -1; }
                if (a.created > b.created) { return 1; }
                return 0;
              })
              let identityCounter = 0;

              const targets = this.guidedService.observablesWithAlignment.filter(o => o.alignment === 'Target');
              identities.forEach(i => {
                if (i.id !== environment.cisaIdentity.id) {
                  if (targets.length > 0
                    && targets[identityCounter]) {
                      this.guidedService.createRelationships(
                        'related-to',
                        targets[identityCounter].id,
                        i.id
                      )
                    }

                  ++identityCounter;
                }
              })
          }
        })
      }, 300)
    }
    
  }

  addFieldArr(field){
    if(!field.arr.includes(field.value) && (field.field_options.includes(field.value) || field.hybrid_options.includes(field.value))){
      field.arr.push(field.value);
      field.value = '';
    }

    this.currentObservableInput[1].show = true;
    this.disableAddToCart(false);
  }

  changeObservableType(resetInput){
    if(resetInput){
      this.currentObservableInput = [];
      for(let input of this.observableInputFields[this.currentObservableType]){
        let tempObj = {}
        for(let field in input){
          if(field === 'arr'){
            tempObj[field] = [];
            continue;
          }
          tempObj[field] = input[field];
        }
        this.currentObservableInput.push(tempObj);
      }
    }
    

    this.currentObservableInfo = this.observableInfo[this.currentObservableType];

    switch(this.currentObservableType){
      case '':
        this.observableValueDropdown = false;
        this.showObservableAlignment = false;
        this.showObservableTime = false;
        this.observableTimeDropdown = false;
        break;
      case 'IPv4 Address':
      case 'IPv6 Address':
      case 'Email Message':
        this.observableValueDropdown = true;
        this.showObservableAlignment = true;
        this.observableTypeDropdown = true;
        this.observableAlignmentDropdown = true;
        this.observableTimeDropdown = true;
        this.showObservableTime = true;
        break;
      case 'Malware':
      case 'Malware Analysis':
        this.observableValueDropdown = true;
        this.showObservableAlignment = false;
        this.observableTypeDropdown = true;
        this.observableAlignmentDropdown = false;
        this.observableTimeDropdown = true;
        this.showObservableTime = true;
        break;
      default:
        this.observableValueDropdown = true;
        this.showObservableAlignment = false;
        this.observableTypeDropdown = true;
        this.observableAlignmentDropdown = false;
        this.observableTimeDropdown = true;
        this.showObservableTime = true;
    }

    if(this.editMode === true){
      this.editMode = false;
      this.editModeEmitter.emit(false);
    }
  }

  convertToUTC(timeZone, first: string, last: string){
    let utc = moment.tz(timeZone).format('Z');

    let result = {};

    if(utc !== ''){
      if(first){
        result['first'] = new Date(`${first.toString().substring(0, 24)} ${utc}`);
      }

      if(last){
        result['last'] = new Date(`${last.toString().substring(0, 24)} ${utc}`);
      }

      return result;
    }

    return result;
  }

  deleteFieldArr(index, field){
    field.arr.splice(index, 1);

    if(field.arr.length === 0 && this.currentObservableType !== 'Email Message' && this.currentObservableType !== 'Malware Analysis')
      this.currentObservableInput[1].show = false;
    
    this.disableAddToCart(false);
  }

  disableAddToCart(isDate){
    if(this.currentObservableInput.length === 0){
      this.disableCartEmitter.emit(true);
      return;
    }

    if(isDate === true && this.firstObserved !== ''){
      this.first_seen = new Date(this.firstObserved);
      if (this.first_seen > new Date() || this.first_seen > this.firstDateStart) 
        this.firstDateStart = this.first_seen;
    }

    if(isDate === true && this.lastObserved !== ''){
      this.last_seen = new Date(this.lastObserved);
      if (this.last_seen < new Date() || this.last_seen < this.lastDateStart)
        this.lastDateStart = this.last_seen;
    }

    for(let input of this.currentObservableInput){
      let valid = this.isValid(input);

      if((!valid && input.show === true)){
        this.disableCartEmitter.emit(true);
        return;
      }
    }

    let disable = false;
    if(this.firstObserved === null) this.firstObserved = '';
    if(this.lastObserved === null) this.lastObserved = '';
    
    if ((this.firstObservedTimeZone !== '' && this.firstObserved === '') || (this.lastObservedTimeZone !== '' && this.lastObserved === '')) {
      disable = true;
    } else if ((this.firstObservedTimeZone === '' && this.firstObserved !== '') || (this.lastObservedTimeZone === '' && this.lastObserved !== '')) {
      disable = true;
    }

    if ((this.firstObserved === '' && this.lastObserved !== '') || (this.firstObserved !== '' && this.lastObserved === '')) {
      disable = true;
    }

    if(this.numberObserved !== '' && this.numberObserved !== null) {
      if (this.firstObserved === '' || this.lastObserved === '')
        disable = true;
    }
    
    if ((this.firstObserved !== '' || this.lastObserved !== '') && (this.numberObserved === '' || this.numberObserved === null)) {
      disable = true;
    }

    if(this.showObservableAlignment === true && this.currentObservableAlignment === 'Attacker' && this.currentAttacker === ''){
      disable = true;
    }

    if (this.showObservableAlignment === true && this.currentObservableAlignment === 'Target' && this.currentTarget === '') {
      disable = true;
    }
    this.disableCartEmitter.emit(disable);
  }

  editCartItem(event: any){
    this.reset();

    let observed: any = {};
    if(event.main && event.observed){
      observed = event.observed;
      event = event.main;
      this.cartIds = [ event.cartId, observed.cartId ];
      this.objectIds = [ event.id, observed.id ];
      
    } else {
      this.cartIds = [ event.cartId ];
      this.objectIds = [ event.id ];
    }

    if(observed){
      for(let field in observed){
        switch(field){
          case 'lastObservedTimeZone':
            this.lastObservedTimeZone = observed.lastObservedTimeZone;
            break;
          case 'firstObservedTimeZone':
            this.firstObservedTimeZone = observed.firstObservedTimeZone;
            break;
          case 'first_seen':
            this.firstObserved = observed.first_seen;
            break;
          case 'last_seen':
            this.lastObserved = observed.last_seen;
            break;
          case 'count':
            this.numberObserved = observed.count;
            break;
          case 'first_observed':
            this.firstObserved = observed.first_observed;
            break;
          case 'last_observed':
            this.lastObserved = observed.last_observed;
            break;
          case 'number_observed':
            this.numberObserved = observed.number_observed;
            break;
        }
      }

      this.observed = observed;
    }

    if (!this.firstObserved)
      this.firstObservedTimeZone = '';
    if (!this.lastObserved)
      this.lastObservedTimeZone = '';

    let type = this.guidedCart.getObjectTypeName(event.type);

    this.currentObservableType = type;
    this.currentObservableInfo = this.observableInfo[type];

    if(event.alignment){
      this.currentObservableAlignment = event.alignment;
      if (event.target) {
        this.currentTarget = event.target;
        this.previousAlignment = `target-${event.target}`;
      } else if (event.attacker) {
        this.previousAlignment = `attacker-${event.attacker}`;
        this.currentAttacker = event.attacker ? event.attacker : '';
      }
    }

    //Has to be copy for value not reference
    this.currentObservableInput = [];
    for(let i in this.observableInputFields[this.currentObservableType]){
      let input = this.observableInputFields[this.currentObservableType][i];
      let tempObj = {}
      for(let field in input){
        let doNotTouch = [];

        switch(this.currentObservableType){
          case 'Artifact':
            doNotTouch = ['currentField', 'currentPlaceholder', 'show'];
            if(field === 'value'){
              if(this.currentObservableInput.length === 0){
                if(event.url){
                  tempObj['currentField'] = 'URL';
                  tempObj['value'] = event.url;
                  tempObj['show'] = true;
                } else if (event.hashes) {
                  for(let key in event.hashes){
                    tempObj['currentField'] = 'Hash';
                    tempObj['value'] = event.hashes[key];
                    tempObj['show'] = true;
                    break;
                  }
                } else if (event.payload_bin) {
                  tempObj['currentField'] = 'Payload Bin';
                  tempObj['value'] = event.payload_bin;
                  tempObj['show'] = true;
                }

                tempObj['currentPlaceholder'] = input.placeholders[tempObj['currentField']];
              } else {
                tempObj['currentField'] = 'hashes';

                if(event.url){
                  for(let key in event.hashes){
                    tempObj['value'] = event.hashes[key];
                    tempObj['show'] = true;
                    break;
                  }

                  continue;
                }

                tempObj['value'] = '';
                tempObj['show'] = false;
              }

              continue;
            } else if (doNotTouch.includes(field)){
              continue;
            }

            tempObj[field] = input[field];
            break;
          case 'Email Message':
            doNotTouch = ['show']
            if(this.currentObservableInput.length === 0){
              if(field === 'value'){
                tempObj['value'] = event[input.currentField];
                tempObj['show'] = true;
                continue;
              }
            } else {
              if(field === 'arr'){
                if(event.is_multipart === 'true'){
                  tempObj['arr'] = event.body_multipart;
                  tempObj['show'] = true;
                } else {
                  tempObj['arr'] = [];
                  tempObj['show'] = false;
                }
                continue;
              }
            }

            if(doNotTouch.includes(field)) continue;

            tempObj[field] = input[field];
            break;
          case 'File':
            doNotTouch = ['currentField', 'currentPlaceholder'];

            if(field === 'value'){
              if(event.name){
                tempObj['value'] = event.name;
                tempObj['currentField'] = 'Name';
                tempObj['currentPlaceholder'] = input.placeholders['Name'];
              } else if (event.hashes) {
                tempObj['currentField'] = 'Hash';
                tempObj['currentPlaceholder'] = input.placeholders['Hash'];
                for(let key in event.hashes){
                  tempObj['value'] = event.hashes[key];
                  break;
                }
              }

              continue;
            } else if(doNotTouch.includes(field)){
              continue;
            }

            tempObj[field] = input[field];
            break;
          case 'Malware Analysis':
            doNotTouch = ['currentField', 'currentPlaceholder', 'type', 'arr', 'hybrid_options', 'hybrid_placeholder'];

            if(this.currentObservableInput.length === 0 && field === 'value'){
              tempObj['value'] = event.product;
              continue;
            } else if (field === 'value'){
              let target = '';

              if(event.result){
                target = 'Result';
                tempObj['value'] = event.result;
                tempObj['arr'] = [];
                
              } else if(event.analysis_sco_refs){
                target = 'Analysis Sco Refs';
                tempObj['value'] = '';
                tempObj['arr'] = event.analysis_sco_refs;
              }
              
              tempObj['currentField'] = target;
              tempObj['currentPlaceholder'] = input.placeholders[target];
              tempObj['type'] = input.type_options[target];
              tempObj['hybrid_placeholder'] = input.placeholders[target].replace('Enter', 'Select');
              tempObj['hybrid_options'] = this.getMalwareAnalysisOptions(tempObj);
              continue;
            } else if(this.currentObservableInput.length !== 0 && doNotTouch.includes(field)){
              continue;
            }

            tempObj[field] = input[field];
            break;
          case 'Network Traffic':
            doNotTouch = ['currentPlaceholder', 'currentField', 'hybird_options', 'hybrid_placeholder', 'show'];

            if(this.currentObservableInput.length === 0 && (field === 'value' || field === 'arr')){
              tempObj['value'] = '';
              tempObj['arr'] = event.protocols;

              continue;
            } else if (field === 'value'){
              let target = '';

              if(event.src_ref){
                target = 'Source Ref';

                tempObj['value'] = event.src_ref;
              } else {
                target = 'Target Ref';

                tempObj['value'] = event.dst_ref;
              }

              tempObj['currentField'] = target;
              tempObj['currentPlaceholder'] = input.placeholders[target];
              tempObj['hybrid_placeholder'] = input.placeholders[target].replace('Enter', 'Select');
              tempObj['hybrid_options'] = this.getNetworkTafficAllowedRefs();
              tempObj['show'] = true;

              continue;
            } else if (this.currentObservableInput.length !== 0 && doNotTouch.includes(field)) {
              continue;
            }

            tempObj[field] = input[field];
            break;
          default:
            if(field === 'value'){
              tempObj[field] = event[input.currentField];
              continue;
            }

            tempObj[field] = input[field];
        }
        
      }
      this.currentObservableInput.push(tempObj);
    }

    this.changeObservableType(false);
    this.disableAddToCart(false);
    this.editMode = true;
  }

  private getCurrentFieldName(currentField){
    let result = '';
    switch(currentField){
      case 'Hash':
        result = `${currentField.toLowerCase()}es`;
        break;
      case 'URL':
        result = `${currentField.toLowerCase()}`;
        break;
      case 'Payload Bin':
        result = `${currentField.toLowerCase()}`;
        result = result.replace(' ', '_');
        break;
      case 'Source Ref':
        result = 'src_ref';
        break;
      case 'Target Ref':
        result = 'dst_ref';
        break;
      case 'Analysis Sco Refs':
          result = 'analysis_sco_refs';
          break;
      default:
        result = currentField.toLowerCase();
    }

    return result;
  }

  getEmailMessageAllowedRefs(){
    let allowedRefs: string[] = ["Artifact"];
    let result = [];

    for(let title of allowedRefs){
      if(!this.guidedCart.cart[title]) continue;

      for(let obj of this.guidedCart.cart[title]){
        result.push(obj);
      }
    }

    return result;
  }

  getMalwareAnalysisOptions(field) {
    switch(field.currentField){
      case 'Result':
        return this.malwareAnalysisResultOptions;
      case 'Analysis Sco Refs':
        let options = [];
        for(let key in this.guidedCart.cart){
          if(key !== 'Malware' && key !== 'Malware Analysis'){
            for(let i in this.guidedCart.cart[key]){
              let item = this.guidedCart.cart[key][i];

              options.push(item.id);
            }
          }
        }

        return options;
    }

    return [];
  }

  getModalAddName(obj){
    if(obj.body) return obj.body;
    if(obj.body_raw_ref) return obj.body_raw_ref;
  }

  getNetworkTafficAllowedRefs(){
    let allowedRefs: string[] = ["IPv4 Address", "IPv6 Address", "Mac Address", "Domain Name"];
    let result = [];

    for(let title of allowedRefs){
      if(this.guidedCart.cart[title] === undefined) continue;

      for(let obj of this.guidedCart.cart[title]){
        result.push(obj.id);
      }
    }

    return result;
  }

  getNetworkTrafficOptions(): string[] {
    let options: string[] = [];

    for(let map of PROTOCOL){
      options.push(map.value);
    }

    return options;
  }

  getObserved(id){
    let observed = {};
    let observedType = 'observed-data';
    let isSighting = false;

    if(this.firstObservedTimeZone !== '' || this.lastObservedTimeZone !== ''){
      observed['firstObservedTimeZone'] = this.firstObservedTimeZone;
      observed['lastObservedTimeZone'] = this.lastObservedTimeZone;
      isSighting = true;
    }
    if(this.firstObserved !== ''){
      let thisType = '';
      switch(observedType){
        case 'sighting':
          thisType = 'first_seen';
          break;
        case 'observed-data':
          thisType = 'first_observed';
          break;
      }
      
      observed[thisType] = this.firstObserved;
      isSighting = true;
    }
    if(this.lastObserved !== ''){
      let thisType = '';
      switch(observedType){
        case 'sighting':
          thisType = 'last_seen';
          break;
        case 'observed-data':
          thisType = 'last_observed';
          break;
      }
      
      observed[thisType] = this.lastObserved;
      isSighting = true;
    }
    if(this.numberObserved !== ''){
      if (!this.firstObserved && !this.lastObserved) {
        this.numberObserved = '';
      } else {
        let thisType = '';
        switch(observedType){
          case 'sighting':
            thisType = 'count';
            break;
          case 'observed-data':
            thisType = 'number_observed';
            break;
        }
        
        observed[thisType] = Number(this.numberObserved);
        isSighting = true;
      }
    }

    if(isSighting === false) return isSighting;

    observed['type'] = observedType;
    observed['cartId'] = this.cartIds[1] ? this.cartIds[1] : null;
    observed['id'] = this.objectIds[1] ? this.objectIds[1] : this.getStixId(observed);

    observed['spec_version'] = '2.1';
    observed['id'] = this.getStixId(observed);
    if(observed['type'] === 'sighting'){
      observed['sighting_of_ref'] = id;
    } else {
      observed['object_refs'] = [ id ];
    }


    return observed;
  }

  private identifyHashes(hash){
    let regex = {
      "MD5": new RegExp('^[a-fA-F0-9]{32}$'),
      "SHA-1": new RegExp('^[0-9a-f]{5,40}$'),
      "SHA-256": new RegExp('^[A-Fa-f0-9]{64}$'),
      "SHA-512": new RegExp('^[a-f0-9]{128}$'),
      "SSDEEP": new RegExp('^(\d{3}):(\w*)\+(\w*):(\w*)$'),
      "TLSH": new RegExp('^T1[a-fA-F0-9]{70}$'),
    }

    for(let exp in regex){
      if(regex[exp].test(hash)){
        let result = {};
        result[`${exp}`] = hash
        return(result);
      }
    }

    return undefined;
  }

  isValid(input){
    if(input.value === '' && !input.type.includes('-add')){
      if(input.type !== 'hybrid-hybrid' && input.currentPlaceholder !== 'No Refs Available') input.error = '';
      return false;
    }

    switch(input.currentField){
      case 'Hash':
      case 'hashes':
        if(this.identifyHashes(input.value) !== undefined){
          input.error = '';
        } else {
          input.error = 'Must be a valid hash (MD5, SHA-1, SHA-256, SHA-512, SSDEEP, TLSH)'
          return false;
        }
        break;
      case 'Name':
      case 'name':
      case 'user_id':
      case 'serial_number':
      case 'is_multipart':
      case 'is_family':
      case 'product':
      case 'result':
      case 'Result':
        input.error = '';
        break;
      case 'number':
        if(!isNaN(input.value) && input.value !== null){
          input.error = '';
        } else {
          input.error = 'Must be a valid Number';
          return false;
        }
        break;
      case 'Payload Bin':
      case 'payload_bin':
        if(this.validationRegex['payload_bin'].test(input.value)){
          input.error = '';
        } else {
          input.error = 'Must be a valid Payload Bin';
          return false;
        }
        break;
      case 'protocols':
      case 'body_multipart':
      case 'Analysis Sco Refs':
      case 'analysis_sco_refs':
        if(input.arr.length === 0)
          return false;
        break;
      case '':
        return false;
      case 'Source Ref':
      case 'src_ref':
      case 'Target Ref':
      case 'dst_ref':
        if(this.validationRegex['ref'].test(input.value)){
          input.error = '';
        } else {
          input.error = 'Must be a valid Reference ID';
          return false;
        }
        break;
      case 'URL':
      case 'url':
        if(this.validationRegex['url'].test(input.value)){
          input.error = '';
        } else {
          input.error = 'Must be a valid URL or URI';
          return false;
        }
        break;
      case 'value':
        let identifier = this.currentObservableType.toLowerCase();
        identifier = identifier.replace(' ', '_');

        if(this.validationRegex[identifier].test(input.value)){
          input.error = '';
        } else {
          input.error = `Not a valid ${this.currentObservableType}`;
          return false;
        }

        break;
      default:
        if(this.validationRegex[input.currentField].test(input.value)){
          input.error = '';
        } else {
          let firstLetter = input.currentField.charAt(0);
          let rest = input.currentField.slice(1);
          input.error = `Not a valid ${firstLetter.toUpperCase() + rest}`;
          return false;
        }
    }
    return true;
  }

  openModal(field){
    let tempRefs = this.getEmailMessageAllowedRefs();

    switch(this.currentObservableType){
      case 'Email Message':
        const multipartRef = this.multipartDialog.open(MultipartDialogComponent, {
          data: { allowedRefs: tempRefs, mode: 'guided', body: '', body_raw_ref: '', content_type: '', content_disposition: '' },
          height: '600px',
          width: `${window.innerWidth / 1.25}px`
        });

        multipartRef.afterClosed().subscribe(result => {
            if (result) field.arr.push(result);
            this.disableAddToCart(false);
        });
    }
  }

  reset(){
    this.currentObservableType = '';
    this.currentObservableAlignment = '';
    this.currentAttacker = '';
    this.currentObservableInfo = [];
    this.currentObservableInput = [];
    this.currentTarget = '';
    this.previousAlignment = '';

    this.firstObservedTimeZone = ''
    this.lastObservedTimeZone = '';
    this.firstObserved = '';
    this.lastObserved = '';
    this.numberObserved = '';
    this.first_seen = undefined;
    this.last_seen = undefined;
    this.lastDateStart = undefined;
    this.firstDateStart = undefined;
  
    this.observableTypeDropdown = false;
    this.observableValueDropdown = false;
    this.observableAlignmentDropdown = false;
    this.showObservableAlignment = false;
    this.showObservableTime = false;
    this.observableTimeDropdown = false;

    this.editMode = false;
    this.cartIds = [];
    this.objectIds = [];

    this.observed = null;
  }

  redirectCart(event){
    if(event.component !== this.component){
      this.changePage.emit(event);
    } else {
      this.getEditItemEmitter.emit(event);
    }
  }

  syncCart(event){
    if(event === this.component){
      this.syncCartEmitter.emit();
    }
  }

  selectChange(event){
    if(this.currentObservableType === 'Email Message'){
      switch(event.target.value){
        case 'true':
          this.currentObservableInput[1].show = true;
          break;
        case 'false':
          this.currentObservableInput[1].show = false;
      }
    }

    this.disableAddToCart(false);
  }

  showAssistanceTrigger(){
    this.showAssistance.emit();
  }

  updateCurrentPlaceholder(event, index){
    let currentObservable = this.currentObservableInput[index];
    if(this.currentObservableType === 'Network Traffic' && index === 1){
      currentObservable.hybrid_options = this.getNetworkTafficAllowedRefs();
      if(currentObservable.hybrid_options.length !== 0){
        currentObservable.hybrid_placeholder = currentObservable.placeholders[event.target.value].replace('Enter', 'Select');
      } else {
        currentObservable.hybrid_placeholder = 'No Refs Available';
        currentObservable.currentPlaceholder = 'No Refs Available';
        currentObservable.error = 'Add IPv4, IPv6, Mac Address, or Domain Name to Cart';
        return;
      }
    } else if(this.currentObservableType === 'Malware Analysis' && index === 1){
      currentObservable.hybrid_options = this.getMalwareAnalysisOptions(currentObservable);
      if(currentObservable.hybrid_options.length !== 0){
        currentObservable.hybrid_placeholder = currentObservable.placeholders[event.target.value].replace('Enter', 'Select');
      } else {
        currentObservable.hybrid_placeholder = 'No Refs Available';
        currentObservable.currentPlaceholder = 'No Refs Available';
        currentObservable.error = 'Add another item to the cart';
        // return;
      }
    } else if (this.currentObservableType === 'Artifact'){
      this.currentObservableInput[1].show = event.target.value === 'URL';
    }
    
    if(currentObservable.type_options){
      currentObservable.type = currentObservable.type_options[event.target.value];
    }

    currentObservable.currentPlaceholder = currentObservable.placeholders[event.target.value];

    this.disableAddToCart(false);
  }

  checkObserved(observed: 'first' | 'last') {
    if (observed === 'first' && !this.firstObserved) {
      this.firstObservedTimeZone = ''
    } else if (observed === 'last' && !this.lastObserved) {
      this.lastObservedTimeZone = ''
    }
  }

  clearObserved(observed: 'first' | 'last') {
    if (observed === 'first') {
      this.firstObserved = '';
      this.firstObservedTimeZone = '';
    } else {
      this.lastObserved = '';
      this.lastObservedTimeZone = '';
    }

    this.disableAddToCart(true);
  }
}
